import DlpRules from '@Policy/DataLossPrevention/PolicyTemplate/Filters/Dlp';

const DlpRulesExchange = () => {
  return (
    <DlpRules
      applyBoundShow={false}
      scanTargetShow={false}
      complianceRuleNoteShow={false}
      advancedOptionsShow={false}
      fileAdvancedOptionsShow={false}
      mipShow={false}
      advancedSettingsShowSalesforce={true}
    />
  );
};
export default DlpRulesExchange;
